<template lang="pug">
  .email-sent.xs-12
    .image-wrapper.text-center
      MrIcon(name="email")

    .title.text-center.upper
      p.xs-f-small.bold {{ title }}

    .subtile-wrap.xs-f-xsmall
      p.xs-mt-100m.xs-mb-100m.text-center We {{ justSent ? 'just ' : '' }}sent a one-time sign in link to your inbox. To verify your email, please click on the link, and voila… you’ll automatically be logged in.

    .error-container.xs-f-xxsmall.text-center
      p.error(v-if="errorMessage" role="alert") {{ errorMessage }}

    .button-wrap
      button.mr-btn.btn-secondary.btn-block.font-xsmall.xs-mt-200m(@click="onResendEmailClicked" :class="{ disabled: processing || errorMessage }")
        span(v-if="!processing") {{ buttonText }}
        MrSpinner(v-else)
</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex';
  import MrIcon from "@components/MrIcon";
  import MrSpinner from "@components/MrSpinner";

  export default {
    name: "EmailSent",
    emits: ['notification-emmited'],

    components: {
      MrIcon,
      MrSpinner,
    },

    props: {
      title: {
        type: String,
        default: '',
      },
      justSent: {
        type: Boolean,
        default: false,
      },
      buttonText: {
        type: String,
        default: '',
      },
    },

    data() {
      return {
        errorMessage: '',
      };
    },

    computed: {
      ...mapState('signIn', [
        'userEmail',
        'processing'
      ]),
    },

    unmounted(){
      this.setView('signIn');
    },

    mounted() {
      this.trackMREvent('Account with no password - message viewed', { email: this.userEmail });
    },

    methods: {
      ...mapActions(['notify']),

      ...mapActions('signIn', [
        'sendMagicLinkEmail',
      ]),

      ...mapMutations('signIn', [
        'setProcessing',
        'setView',
      ]),

      handleMagicLinkSent(emmitNotification) {
        this.magicLinkSent = 'email';
        this.trackMREvent('Sign in - re-sent Magic link', { email: this.userEmail });
        this.setProcessing(false);

        if (emmitNotification) {
          let notification = {
            class: "success",
            message: "We have just sent you a new one-time login link to your email.",
            time: 10000,
          };

          this.$emit('notification-emmited', notification);
        }
      },

      handleMagicLinkSentError (err) {
        this.setProcessing(false);
        let error = err.response;

        if (error.data) {
          if (error.data.code == "UNSUBSCRIBED") {
            let notification = {
              class: "warn",
              message: "It looks like you might not be getting our password reset emails. If you do not receive one shortly please contact Color Crew for assistance.",
              time: 10000,
            };

            this.$emit('notification-emmited', notification);

          } else {
            this.errorMessage = error.data.message;
          }
        }
      },

      onResendEmailClicked() {
        this.sendMagicLinkEmail().then(() => this.handleMagicLinkSent(true)).catch(this.handleMagicLinkSentError);
        this.trackMREvent('Account with no password - Magic link re-send clicked', { email: this.userEmail });
      },
    },
  };
</script>

<style scoped lang="stylus">
  .email-sent
    margin-top 50%
    transform translateY(-25%)

    .image-wrapper
      .mr-icon
        width 68px
        margin-bottom 1em

        :deep(path)
          &.borderline
            fill #060606
          &.envelopeSpace
            fill #FEFEFE

    .title
      padding 0.5em 0em

</style>
